import React from 'react'
import styled from 'styled-components'
import { CircularProgress } from '@mui/material'

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Loader = ({size="3rem"}) => (
    <Wrapper>
        <CircularProgress size={size} sx={{ color: '#214c45' }} />
    </Wrapper>
);

export default Loader;
